import styles from "Styles/ErrorPage.module.css";
import { Button } from "Components/Button.js";

function ErrorPage() {
  return (
    <div className={styles.container}>
      <div className={styles.headings}>
        <h1>404</h1>
        <h3>Page not found</h3>
      </div>
      <Button type="link" to="/">
        Go to homepage
      </Button>
    </div>
  );
}

export default ErrorPage;
